import Vue from 'vue'
import VueRouter from 'vue-router'
import Consorcios from '../views/Consorcios.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Consorcios',
    component: Consorcios
  },
  {
    path: '/consorcio/ficha-tecnica/:id',
    name: 'FichaTecnica',
    component: () => import(/* webpackChunkName: "about" */ '../views/FichaTecnica.vue')
  },
  {
    path: '/usuarios',
    name: 'Usuarios',
    component: () => import(/* webpackChunkName: "about" */ '../views/Usuarios.vue')
  },
  {
    path: '/meu-perfil',
    name: 'MeuPerfil',
    component: () => import(/* webpackChunkName: "about" */ '../views/MeuPerfil.vue')
  },
  {
    path: '/*',
    name: '404',
    component: () => import(/* webpackChunkName: "about" */ '../views/Consorcios.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
